(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-contact"]) return;
  try {
    
  var itemsUploading = 0;
  var warrantyMode = false;
  var contactMenuSelector = document.querySelector('#page-contact-how-can-we-help');
  if (contactMenuSelector) {
    contactMenuSelector.selectedIndex = 0;
    contactMenuSelector.onchange = function(e) {
      if (! e.target.value) {
        return;
      }
      var targetOption = e.target.value.toLowerCase(); 

      resetAllContainers();
      switch(targetOption) {
        case "order status":
        case "shipping & tracking":
        case "cancelations":
          displayContainer('page-contact-order-number', true);
          break;
        case "returns":
          displayContainer('page-contact-order-number', true);
          displayContainer('page-contact-returns-image', true);
          break;
        case "update delivery address":
          displayContainer('page-contact-order-number', true);
          displayContainer('page-contact-warranty-claim-shipping-address-new-address', true);
          break;
        case "defects & warranty claims":
          displayContainer('page-contact-order-number', true);
          displayContainer('page-contact-warranty-claim-what-product-affected', true);

          warrantyMode = true;
          updateSubmitState();
          break;
        default:
          resetAllContainers();
          break;
      }
    };
  }

  var productMenuSelector = document.querySelector('#page-contact-warranty-claim-what-product-affected');
  if (productMenuSelector) {
    productMenuSelector.selectedIndex = 0;
    productMenuSelector.onchange = function(e) {
      if (! e.target.value) {
        return;
      }
      var targetOption = e.target.value.toLowerCase(); 

      switch(targetOption) {
        case "the nugget":
            displayContainer('page-contact-warranty-claim-which-piece-affected', true);
            displayContainer('page-contact-warranty-claim-which-piece-affected-chunk', false);
            displayContainer('page-contact-warranty-claim-which-piece-affected-smore', false);
            displayContainer('page-contact-warranty-claim-where-issue-on-nugget', true);
            displayContainer('page-contact-warranty-claim-where-issue-on-chunk', false);
            displayContainer('page-contact-warranty-claim-where-issue-on-smore', false);
            displayContainer('page-contact-warranty-claim-what-is-color-name', true);
            displayContainer('page-contact-warranty-claim-what-is-color-name-chunk', false);
            displayContainer('page-contact-warranty-claim-what-is-color-name-smore', false);
            displayContainer('page-contact-warranty-claim-shipping-address', true);
            displayContainer('page-contact-warranty-claim-lot-tag', true);
            displayContainer('page-contact-warranty-claim-impact-area', true);
            
            if (document.getElementById('page-contact-warranty-claim-lot-tag-nugget-container')) {
              document.getElementById('page-contact-warranty-claim-lot-tag-nugget-container').style.display = 'inline';
            }
            if (document.getElementById('page-contact-warranty-claim-lot-tag-chunk-container')) {
              document.getElementById('page-contact-warranty-claim-lot-tag-chunk-container').style.display = 'none';
            }
            if (document.getElementById('page-contact-warranty-claim-lot-tag-smore-container')) {
              document.getElementById('page-contact-warranty-claim-lot-tag-smore-container').style.display = 'none';
            }
            if (document.getElementById('tag-lot-container-nugget')) {
              document.getElementById('tag-lot-container-nugget').style.display = 'inline';
            }
          break;
        case "chunk":
            displayContainer('page-contact-warranty-claim-which-piece-affected', false);
            displayContainer('page-contact-warranty-claim-which-piece-affected-chunk', true);
            displayContainer('page-contact-warranty-claim-which-piece-affected-smore', false);
            displayContainer('page-contact-warranty-claim-where-issue-on-nugget', false);
            displayContainer('page-contact-warranty-claim-where-issue-on-chunk', true);
            displayContainer('page-contact-warranty-claim-where-issue-on-smore', false);
            displayContainer('page-contact-warranty-claim-what-is-color-name', false);
            displayContainer('page-contact-warranty-claim-what-is-color-name-chunk', true);
            displayContainer('page-contact-warranty-claim-what-is-color-name-smore', false);
            displayContainer('page-contact-warranty-claim-shipping-address', true);
            displayContainer('page-contact-warranty-claim-lot-tag', true);
            displayContainer('page-contact-warranty-claim-impact-area', true);
            
            if (document.getElementById('page-contact-warranty-claim-lot-tag-nugget-container')) {
              document.getElementById('page-contact-warranty-claim-lot-tag-nugget-container').style.display = 'none';
            }
            if (document.getElementById('page-contact-warranty-claim-lot-tag-chunk-container')) {
              document.getElementById('page-contact-warranty-claim-lot-tag-chunk-container').style.display = 'inline';
            }
            if (document.getElementById('page-contact-warranty-claim-lot-tag-smore-container')) {
              document.getElementById('page-contact-warranty-claim-lot-tag-smore-container').style.display = 'none';
            }
            if (document.getElementById('tag-lot-container-nugget')) {
              document.getElementById('tag-lot-container-nugget').style.display = 'none';
            }
          break;
        case "smore":
            displayContainer('page-contact-warranty-claim-which-piece-affected', false);
            displayContainer('page-contact-warranty-claim-which-piece-affected-chunk', false);
            displayContainer('page-contact-warranty-claim-which-piece-affected-smore', true);
            displayContainer('page-contact-warranty-claim-where-issue-on-nugget', false);
            displayContainer('page-contact-warranty-claim-where-issue-on-chunk', false);
            displayContainer('page-contact-warranty-claim-where-issue-on-smore', true);
            displayContainer('page-contact-warranty-claim-what-is-color-name', false);
            displayContainer('page-contact-warranty-claim-what-is-color-name-chunk', false);
            displayContainer('page-contact-warranty-claim-what-is-color-name-smore', true);
            displayContainer('page-contact-warranty-claim-shipping-address', true);
            displayContainer('page-contact-warranty-claim-lot-tag', true);
            displayContainer('page-contact-warranty-claim-impact-area', true);
            
            if (document.getElementById('page-contact-warranty-claim-lot-tag-nugget-container')) {
              document.getElementById('page-contact-warranty-claim-lot-tag-nugget-container').style.display = 'none';
            }
            if (document.getElementById('page-contact-warranty-claim-lot-tag-chunk-container')) {
              document.getElementById('page-contact-warranty-claim-lot-tag-chunk-container').style.display = 'none';
            }
            if (document.getElementById('page-contact-warranty-claim-lot-tag-smore-container')) {
              document.getElementById('page-contact-warranty-claim-lot-tag-smore-container').style.display = 'inline';
            }
            if (document.getElementById('tag-lot-container-nugget')) {
              document.getElementById('tag-lot-container-nugget').style.display = 'none';
            }
          break;
      }
    };
  }

  var modalLinks = document.querySelectorAll('.modalLink');
  for (let i = 0; i < modalLinks.length; i++) {
    modalLinks[i].addEventListener("click", function() {
      var modalTarget = document.getElementById(modalLinks[i].dataset.modal);
      if (modalTarget) modalTarget.classList.add('cc-popup--visible');
      document.body.classList.add('cc-modal-visible');
    });
  }

  var closeModalLinks = document.querySelectorAll('.cc-popup-close-gg');
  for (let i = 0; i < closeModalLinks.length; i++) {
    closeModalLinks[i].addEventListener("click", function() {
      var closeTarget = document.getElementById(closeModalLinks[i].dataset.modalclose);
      if (closeTarget) closeTarget.classList.remove('cc-popup--visible');
      document.body.classList.remove('cc-modal-visible');
    });
  }

  var closeModalLinksViaBG = document.querySelectorAll('.cc-popup-background');
  for (let i = 0; i < closeModalLinksViaBG.length; i++) {
    closeModalLinksViaBG[i].addEventListener("click", function() {
      var closeBgTarget = document.getElementById(closeModalLinksViaBG[i].dataset.modalclose);
      if (closeBgTarget) closeBgTarget.classList.remove('cc-popup--visible');
      document.body.classList.remove('cc-modal-visible');
    });
  }

  function resetAllContainers() {
      const containerItems = document.querySelectorAll("[id$='-container']");
       containerItems.forEach(function(containerItem) {
        containerItem.style.display = "none";
        const hiddenForms = containerItem.querySelectorAll(".required-when-shown");
        hiddenForms.forEach(function(hiddenItem) {
          hiddenItem.required = false;
          hiddenItem.style.display = 'none';
          hiddenItem.disabled = true;
        });
      });
      
      var productSelector = document.getElementById('page-contact-warranty-claim-what-product-affected');
      if (productSelector) productSelector.selectedIndex = 0;

      warrantyMode = false;
      clearAllAttachments();
      updateSubmitState();
   }


  function displayContainer(container, state, callback) {
    var displayState = (!state) ? 'none' : 'block';
    var localContainer = document.querySelector('#'+container+'-container');

    if (localContainer) {
      localContainer.style.display = displayState;
      var localHiddenItems = localContainer.querySelectorAll(".required-when-shown");
      localHiddenItems.forEach(function(localHiddenItem) {
        if (state == true) {
          localHiddenItem.required = true;
          localHiddenItem.disabled = false;
          localHiddenItem.style.display = 'block';
        }
        if (state == false) {
          localHiddenItem.required = false;
          localHiddenItem.disabled = true;
          localHiddenItem.style.display = 'none';
        }
      });
    }
    
    if (callback !== undefined && typeof(callback) == 'function') {
      callback();
    }
  }

  var uploadCounts = { impactImage: 0, lotTag: 0, returnsImage: 0 };
  var uploadUid = 0;

  function updateSubmitState() {
    var submitBtn = document.getElementById('nugget_form_submit');
    var submitMsg = document.getElementById('nugget_form_submit_message');
    if (!submitBtn) {
      return;
    }

    if (itemsUploading > 0) {
      submitBtn.disabled = true;
      if (submitMsg) {
        submitMsg.classList.remove('hidden');
        submitMsg.innerHTML = 'Please wait — your image is still uploading…';
      }
      return;
    }

    if (warrantyMode && (uploadCounts.impactImage < 1 || uploadCounts.lotTag < 1)) {
      submitBtn.disabled = true;
      if (submitMsg) {
        submitMsg.classList.remove('hidden');
        submitMsg.innerHTML = 'Please add at least one impact image and one lot tag image to submit your claim.';
      }
      return;
    }

    submitBtn.disabled = false;
    if (submitMsg) {
      submitMsg.innerHTML = '';
      submitMsg.classList.add('hidden');
    }
  }

  function clearAllAttachments() {
    uploadCounts.impactImage = 0;
    uploadCounts.lotTag = 0;
    uploadCounts.returnsImage = 0;
    itemsUploading = 0;

    var previews = document.querySelectorAll('.js-attachment-preview');
    previews.forEach(function(preview) {
      if (preview.parentNode) {
        preview.parentNode.removeChild(preview);
      }
    });

    ['impactImageAdd', 'lotTagAdd', 'returnsImageAdd'].forEach(function(buttonId) {
      var btn = document.getElementById(buttonId);
      if (btn) {
        btn.style.display = '';
      }
    });

    ['clickToRemove_impactImage', 'clickToRemove_lotTag', 'clickToRemove_returnsImage'].forEach(function(noteId) {
      var note = document.getElementById(noteId);
      if (note) {
        note.style.display = 'none';
      }
    });
  }

  // Uploads a single file, builds the preview immediately (not tied to upload
  // progress), surfaces failures to the user, and only counts the image toward
  // the submit gate once it has successfully uploaded and a hidden field holds
  // its returned path.
  // Lazy-loads the heic2any converter the first time a HEIC/HEIF file is picked,
  // so the ~1.3MB library never loads for the common JPG/PNG case.
  var heicLibPromise = null;

  function ensureHeic2any() {
    if (window.heic2any) {
      return Promise.resolve();
    }
    if (heicLibPromise) {
      return heicLibPromise;
    }

    heicLibPromise = new Promise(function(resolve, reject) {
      if (typeof heic2anyAssetUrl === 'undefined' || !heic2anyAssetUrl) {
        reject(new Error('HEIC converter URL is unavailable.'));
        return;
      }

      var script = document.createElement('script');
      script.src = heic2anyAssetUrl;
      script.onload = function() {
        if (window.heic2any) {
          resolve();
        } else {
          reject(new Error('HEIC converter failed to initialise.'));
        }
      };
      script.onerror = function() {
        reject(new Error('HEIC converter failed to load.'));
      };
      document.head.appendChild(script);
    });

    return heicLibPromise;
  }

  function isHeicFile(file) {
    return /image\/hei[cf]/i.test(file.type) || /\.hei[cf]$/i.test(file.name || '');
  }

  // Resolves with an upload-ready File. HEIC/HEIF is converted to JPEG client-side
  // (iPhone/Mac default format); everything else passes through untouched.
  function prepareUploadFile(file) {
    if (!isHeicFile(file)) {
      return Promise.resolve(file);
    }

    return ensureHeic2any().then(function() {
      return window.heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 });
    }).then(function(result) {
      var blob = Array.isArray(result) ? result[0] : result;
      var newName = (file.name || 'image').replace(/\.[^.]+$/, '') + '.jpg';
      return new File([blob], newName, { type: 'image/jpeg' });
    });
  }

  function uploadAttachment(file, targetName, addButton, maxCount) {
    var container = addButton.parentNode;
    var uid = 'id_' + (++uploadUid);
    var settled = false;
    var succeeded = false;
    var cancelled = false;
    var source = axios.CancelToken.source();

    var wrapper = document.createElement('button');
    wrapper.type = 'button';
    wrapper.className = 'js-attachment-preview';
    wrapper.setAttribute('aria-label', 'Image added, click to remove');
    wrapper.style.display = 'block';
    wrapper.style.verticalAlign = 'top';
    wrapper.style.cursor = 'pointer';
    wrapper.style.marginBottom = '20px';
    wrapper.style.marginRight = '20px';
    wrapper.style.background = 'none';
    wrapper.style.border = 'none';
    wrapper.style.borderRadius = '0';
    wrapper.style.padding = '0';

    var img = document.createElement('img');
    img.alt = 'Attached image preview';
    img.style.height = '100px';
    img.style.width = 'auto';
    img.style.opacity = '0.35';
    wrapper.appendChild(img);

    var status = document.createElement('span');
    status.style.display = 'block';
    status.style.fontSize = '12px';
    status.textContent = isHeicFile(file) ? 'Converting photo…' : 'Uploading…';
    wrapper.appendChild(status);

    container.appendChild(wrapper);

    var removeNote = document.getElementById('clickToRemove_' + targetName);
    if (removeNote) {
      removeNote.style.display = 'inline';
    }

    itemsUploading++;
    updateSubmitState();

    // Guarantees itemsUploading is decremented exactly once across every exit
    // path (success, error, conversion failure, or cancellation).
    function settleOnce() {
      if (settled) {
        return false;
      }
      settled = true;
      itemsUploading--;
      return true;
    }

    function finishWithError(message) {
      if (!settleOnce()) {
        return;
      }
      img.style.opacity = '1';
      status.textContent = message;
      status.style.color = 'red';
      updateSubmitState();
    }

    function removeAttachment() {
      cancelled = true;
      if (!settled) {
        source.cancel('Operation cancelled by user');
        settleOnce();
      }
      if (succeeded) {
        uploadCounts[targetName] = Math.max(0, uploadCounts[targetName] - 1);
      }
      if (wrapper.parentNode) {
        wrapper.parentNode.removeChild(wrapper);
      }
      if (addButton && uploadCounts[targetName] < maxCount) {
        addButton.style.display = '';
      }
      updateSubmitState();
    }

    wrapper.onclick = removeAttachment;

    function doUpload(preparedFile) {
      if (cancelled) {
        settleOnce();
        updateSubmitState();
        return;
      }

      var previewReader = new FileReader();
      previewReader.onload = function(readerEvent) {
        img.src = readerEvent.target.result;
      };
      previewReader.readAsDataURL(preparedFile);

      status.textContent = 'Uploading…';

      var formData = new FormData();
      formData.append('attachment', preparedFile, preparedFile.name);

      axios.post(contactFormLaunchUrl, formData, {
        cancelToken: source.token,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(function(response) {
        if (!response || !response.data || !response.data.path) {
          finishWithError('Upload failed — tap this image to remove it and try again.');
          return;
        }
        if (!settleOnce()) {
          return;
        }

        succeeded = true;
        img.style.opacity = '1';
        status.textContent = 'Click image to remove';
        status.style.color = '';

        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'contact[' + targetName + uid + ']';
        hidden.value = response.data.path;
        wrapper.appendChild(hidden);

        uploadCounts[targetName]++;
        if (addButton && uploadCounts[targetName] >= maxCount) {
          addButton.style.display = 'none';
        }
        updateSubmitState();
      }).catch(function(error) {
        if (axios.isCancel && axios.isCancel(error)) {
          settleOnce();
          updateSubmitState();
          return;
        }
        finishWithError('Upload failed — tap this image to remove it and try again.');
      });
    }

    prepareUploadFile(file).then(doUpload, function() {
      finishWithError('Could not process this HEIC photo — please upload a JPG or PNG instead.');
    });
  }

  function attachUploader(buttonId, targetName, maxCount) {
    var addButton = document.getElementById(buttonId);
    if (!addButton) {
      return;
    }

    addButton.addEventListener('click', function() {
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/png, image/jpeg, image/heic, image/heif, .heic, .heif';
      input.style.display = 'none';

      input.addEventListener('change', function() {
        var file = input.files && input.files[0];
        if (file) {
          uploadAttachment(file, targetName, addButton, maxCount);
        }
        if (input.parentNode) {
          input.parentNode.removeChild(input);
        }
      });

      document.body.appendChild(input);
      input.click();
    });
  }

  attachUploader('impactImageAdd', 'impactImage', 4);
  attachUploader('lotTagAdd', 'lotTag', 1);
  attachUploader('returnsImageAdd', 'returnsImage', 2);

  window.onload = function() {
    resetAllContainers();
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadRelatedProductsIntoSection = function() {
  // Look for an element with class 'related-products'
  var relatedProductsSection = document.querySelector('.related-products');
  if (relatedProductsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", relatedProductsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      relatedProductsSection.innerHTML = container.querySelector('.related-products').innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadRelatedProductsIntoSection();
  }
});
// Fetch the products on page load
loadRelatedProductsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
